<!-- 德育档案 -->
<template>
   <div class="box">
      <div class="fuzzy-matching-top">
         <el-row class="top-first-line the-second-line search-box-top">
            <el-col :span="4">
               <!-- <el-form-item label="部门:"> -->
               <el-select v-model="searchFoem.department" filterable placeholder="请选择" remote :remote-method="searchQuery" @change="selectOnClick" >
                  <el-option  v-for="item in departmentList" :key="item.value" :label="item.name" :value="item.studentOrTeacherId">
                  </el-option>
               </el-select>
               <!-- </el-form-item> -->
            </el-col>

            <el-col :span="5">
               <el-form-item label="开始时间:">
                  <el-date-picker v-model="searchFoem.startTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
                  </el-date-picker>
               </el-form-item>
            </el-col>
            <el-col :span="5">
               <el-form-item label="结束时间:">
                  <el-date-picker v-model="searchFoem.terminalTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
                  </el-date-picker>
               </el-form-item>
            </el-col>

            <el-button type="primary" size="medium" class="query-button" @click="inquiryClick">查询</el-button>
            <el-button type="primary" size="medium" @click='downloadPDF'>
               <Document class="pdf-ico"></Document>
               转为PDF
            </el-button>
         </el-row>
      </div>
      <div class="pdf-box" ref="pdfContent" id="pdfContent" v-if="formShow">
         <div class="form-table">
            <div class="school_name_box">
               {{information.username }}
            </div>
            <div class="title_box">
               {{ '德育档案' }}
            </div>
            <div class="essential_information_box" >
               <div class="cen_essential_box">
                  <div class="left_essential_box">
                     <img src="./img/touxiang.png" alt="" class="img_box">
                  </div>
                  <div class="right_box">
                     <div class="right_essential_box">
                        <div class="right_essential_row">
                           姓名：{{name}}
                        </div>
                        <!-- <div class="right_essential_row">
                           性别：
                        </div> -->
                     </div>
                     <div class="right_essential_box">
                        <!-- <div class="right_essential_row">
                           班级：
                        </div> -->
                        <!-- <div class="">
                           出生年月：{{ information.created }}
                        </div> -->
                     </div>
                     <div class="right_essential_box">
                        电话：{{ information.mobile }}
                     </div>
                     <div class="right_essential_box">
                        邮箱：{{information.email || '暂无'}}
                     </div>
                     <!-- <div class="right_essential_box">
                        身份证：
                     </div>
                     <div class="right_essential_box">
                        家庭住址：
                     </div> -->
                  </div>

               </div>
            </div>
            <div class="bottom_title_box" v-if="departmentItem.type == 'student'" >
               <div class="comprehensive_score_title">
                  {{ '2025年综合得分' }}
               </div>
               <div class="date_title">
                  {{ `考核周期： ${searchFoem.startTime} 至 ${searchFoem.terminalTime}` }}
               </div>
            </div>
            <div class="descriptions_row" v-if="departmentItem.type == 'student'" >
               <el-descriptions class="margin-top" title="" :column="3" :size="size" border>
                  <el-descriptions-item>
                     <template #label>
                        总分
                     </template>
                     {{ rankingData.totalScore }}
                  </el-descriptions-item>
                  <el-descriptions-item>
                     <template #label>
                        班级排名
                     </template>
                     {{ rankingData.annualOverallRanking }}
                  </el-descriptions-item>
               </el-descriptions>
            </div>
            <div class="date_list_box" v-for="item in list" v-if="departmentItem.type == 'student'" >
               <div class="bottom_title_box2">
                  <div class="comprehensive_score_title2">
                     {{ item.time+'综合得分' }}
                  </div>
                  <div class="date_title2">
                     {{ item.time+'-01' }} 至 {{ item.time+'-31' }}
                  </div>
               </div>
               <div class="top_row_aggregate">
                  <div class="score-le">
                     总分：{{ item.totalScore }}
                  </div>
                  <div class="ranking-ri">
                     班级排名：{{ item.ranking }}
                  </div>
               </div>
               <el-table stripe :border="true" class="table-Style"
                  :header-cell-style="{ background: '#EDF6FF', color: '#000', }" ref="multipleTable"
                  :data="item.checkRecords" tooltip-effect="dark" style="width: 100%">
                  <el-table-column prop="memberName" label="姓名">
                  </el-table-column>
                  <el-table-column prop="checkItemName" label="项目">
                  </el-table-column>
                  <!-- <el-table-column prop="code" label="分类">
                  </el-table-column> -->
                  <el-table-column prop="checkItemName" label='考核项'>
                  </el-table-column>
                  <el-table-column prop="score" label="分数">
                  </el-table-column>
                  <el-table-column prop="checkUserName" label="考核人">
                  </el-table-column>
                  <el-table-column prop="created" label="时间">
                  </el-table-column>
                  <el-table-column prop="comment" label="备注">
                  </el-table-column>
               </el-table>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import { userList,annualOverallRanking,monthStatistics } from '@/assets/api/deyu.js';
import { menuGetUserById} from '@/assets/api/user.js'
import { findTeacherInfo } from '@/assets/api/renyuan';
import { Document, } from "@element-plus/icons-vue"; // 图标
import { ElMessage } from 'element-plus'
// // import { jsPDF } from "jspdf"; 
// // import html2pdf from "html2pdf.js";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
export default {
   name: '',
   components: {
      Document
   },
   mixins: [],
   props: {

   },
   data() {
      return {
         searchFoem: {
            department: '',
            startTime: '',
            terminalTime: ''
         },
         departmentList: [
        
         ],
         list: [],
         teacherObj: {},
         inputValue: '',
         formShow: false,
         departmentItem: {},
         information: {},
         rankingData: {},
         scoreData: {},
         name:"",
      }
   },
   computed: {
      
   },
   watch: {

   },
   created() {
      this.Lookteacher()
      this.handleNodeClick()
   },
   mounted() {

   },
   methods: {
      handleNodeClick(){
         const params = {
            userId: JSON.parse(localStorage.getItem('user')).id,
         }
         menuGetUserById(params).then((res)=> {
            console.log(res,'成功123');
            this.information = res.data.data
 
         }).catch((err) => {
            console.log(err,'失败');
         })
         
      },
      selectOnClick (val) {
         console.log(val,'选择');
         this.departmentItem = this.departmentList.find(option => option.studentOrTeacherId === val);
         console.log(this.departmentItem.name,'选中的对象');
         this.name = this.departmentItem.name
        
      },
      searchQuery(query) {
         // 在这里调用查询接口，并处理返回的数据
         if (query !== ''  ) {
            if ( this.teacherObj.schoolId != '' && this.teacherObj.schoolId != null  ) {
               this.userListPost(query);
            } else {
               console.log('暂无权限');
            }
            console.log(query,'55555555555');
         } else {
         // 如果输入为空，可以清空options或者执行其他逻辑
         }
      },
      Lookteacher() {
         let params = {
            userId: JSON.parse(localStorage.getItem('user')).id,
         }
         findTeacherInfo(params).then((res) => {
            console.log(res, '查看权限');
            this.teacherObj = res.data.data
         }).catch((err) => {
         console.log(err);
         })
      },
      annualOverallRanking() {
         let params = {
            studentId: this.departmentItem.studentOrTeacherId,
            startTime: this.searchFoem.startTime,
            endTime: this.searchFoem.terminalTime,
         }
         annualOverallRanking(params).then((res)=> {
            console.log(res,'排名');
            this.rankingData = res.data.data
         }).catch((err)=> {
            console.log(err);
         })
      },
      monthStatistics() {
         let params = {
            studentId: this.departmentItem.studentOrTeacherId,
            startTime: this.searchFoem.startTime,
            endTime: this.searchFoem.terminalTime,
         }
         monthStatistics(params).then((res)=> {
            console.log(res,'得分');
            // this.scoreData = res.data.data
            this.list = res.data.data
         }).catch((err)=> {
            console.log(err);
         })
      },
      userListPost(value) {
         userList(value,this.teacherObj.schoolId).then((res) => {
         this.departmentList = res.data.data
         }).catch((err) => {
         console.log(err);
         })
      },
      shijianGuolv (value) {

      },
      inquiryClick() {
         console.log('查询');
         if ( JSON.stringify(this.departmentItem) != '{}' && this.searchFoem.startTime!=''&& this.searchFoem.terminalTime!='' ) {
            this.formShow = true
            this.annualOverallRanking()
            this.monthStatistics()
         } else {
            ElMessage({
               message: '查询条件请输入完整',
               type: 'warning',
            })
         }
      },
      async  downloadPDF() {
         const element = this.$refs.pdfContent; // 需要转换为PDF的DOM元素
         element.style.height = element.scrollHeight + "px";
         html2canvas(element, {
				allowTaint: true,
				taintTest: false,
				useCORS: true,
				// y: 72, // 对Y轴进行裁切
				// width:1200,
				// height:5000,
				// dpi: window.devicePixelRatio * 4, //将分辨率提高到特定的DPI 提高四倍
				scale: 2 //按比例增加分辨率 
			}).then(function(canvas) {
				let contentWidth = canvas.width
				let contentHeight = canvas.height
				let pageHeight = contentWidth / 592.28 * 841.89
				let leftHeight = contentHeight
				let position = 0
				let imgWidth = 595.28
				let imgHeight = 592.28 / contentWidth * contentHeight
				let pageData = canvas.toDataURL('image/jpeg', 1.0)
				let PDF = new jsPDF('', 'pt', 'a4')
				if (leftHeight < pageHeight) {
					PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
				} else {
					while (leftHeight > 0) {
						PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
						leftHeight -= pageHeight
						position -= 841.89
						if (leftHeight > 0) {
							PDF.addPage()
						}
					}
				}
				PDF.save('阿打算' + '.pdf')
			})
      }
   }
};
</script>
<style lang='scss' scoped>
.box {
   width: 100%;
   height: 96%;
   background-color: #fff;
   overflow: auto;
   // background-color: #fff;
   .fuzzy-matching-top {
      height: 100px;
      // background-color: #fff;
      // border-radius: 15px;
      display: flex;
      align-content: space-around;
      align-items: center;
      padding: 0px 20px;

      .titleStyle {
         margin-left: 40px;
         font-size: 20px;
         font-weight: 700;
         width: 45%;
      }

      :deep() {
         // .el-input--small .el-input__wrapper {


         .el-input {
            height: 35px;
         }

         .el-select--small .el-select__wrapper {
            width: 95%;
            height: 35px;
            margin-right: 15px;
            // border-radius: 15px;
         }

         .el-range-editor--small.el-input__wrapper {
            height: 35px;
            line-height: 35px;
         }

         .box .fuzzy-matching-top[data-v-9c071972] .el-input--small .el-input__wrapper {
            margin-right: 0px;
         }

         .box .fuzzy-matching-top[data-v-9c071972] .el-input {
            width: 95%;
         }
         .el-select .el-input__wrapper{
            width: 250px;
         }
      }

      .the-second-line {
         width: 100%;

         .query-button {
            padding: 16px 24px;
            // background-color: #1BC896;
            margin-left: 40px;
            border-radius: 15px;

         }

         .pdf-ico {
            width: 20px;
            margin-right: 6px;
         }
         :deep() {
            
            .el-form-item--small .el-form-item__label {
               // background-color: red;
               font-size: 16px;
            }
            .el-form-item--small .el-form-item__label {
               width: 110px;
               text-align: right;
               height: 35px;
               line-height: 35px;
            }
         }
      }



   }

   .pdf-box {
      height: 80%;
      overflow: auto;

      // position: relative;
      .form-table {
         // height: 100%;
         width: 60%;
         border: 1px solid #ebeef5;
         padding: 40px 30px;
         // margin-left: 50% ;
         margin: auto;

         .school_name_box {
            margin: 20px 0px;
            text-align: center;
            font-weight: normal;
            font-size: 16px;
         }

         .title_box {
            font-size: 24px;
            font-weight: 700;
            text-align: center;
            margin: 20px 0px;
         }

         .essential_information_box {
            margin: 20px 0px;
            border-top: 1px solid #ebeef5;
            border-bottom: 1px solid #ebeef5;
            padding: 20px 0px;
            background-color: rgb(249, 249, 249);
            margin-bottom: 40px;

            .cen_essential_box {
               display: flex;

               .left_essential_box {
                  flex: 35%;
                  text-align: center;

                  .img_box {
                     width: 120px;
                     height: 160px;
                     // background-color: #fff;
                  }
               }

               .right_box {
                  flex: 65%;

                  .right_essential_box {
                     // justify-content: space-around;  /* 子元素左右平均分配宽度 */
                     // align-items: center;             /* 垂直居中 */
                     display: flex;
                     line-height: 40px;
                     font-size: 14px;
                     color: #606266;

                     .right_essential_row {
                        width: 30%;
                     }
                  }
               }
            }
         }

         .bottom_title_box {
            text-align: center;

            .comprehensive_score_title {
               font-weight: normal;
               font-size: 16px;
               margin-bottom: 10px;
            }

            .date_title {
               color: #a9a9a9;
               font-size: 14px;
            }
         }

         .descriptions_row {
            margin-top: 20px;

            :deep() {
               .el-descriptions--small .el-descriptions__body .el-descriptions__table.is-bordered .el-descriptions__cell {
                  text-align: center;
                  width: 25%;
               }
            }
         }

         .date_list_box {
           margin-top: 20px;
            .bottom_title_box2 {
               text-align: center;
               margin-top: 20px;
               margin-bottom: 8px;

               .comprehensive_score_title2 {
                  font-weight: normal;
                  font-size: 16px;
               }

               .date_title2 {
                  color: #a9a9a9;
                  font-size: 14px;
               }
            }

            .top_row_aggregate {
               display: flex;

               .score-le {
                  font-size: 14px;
                  color: rgb(96, 98, 102);
                  line-height: 42px;
                  margin-right: 40px;
               }

               .ranking-ri {
                  font-size: 14px;
                  color: rgb(96, 98, 102);
                  line-height: 42px;
               }
            }

            .table-Style {
               font-size: 14px;
            }
         }
      }
   }
}
</style>